import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Grid } from '@mui/material';
import { Form } from './styled';
import { BasePage } from '../../../../../components/BaseMain';
import { goToAdmin, goToSectorsList } from '../../../../../router/coordinator';
import {
  AlertMessage,
  Loading,
  Modal,
  TextFieldKeyPress,
  TextFieldNextFocus,
  TitlePages
} from '../../../../../components';
import { clearAlertMessage, isDesktop } from '../../../../../utils';
import { useForm } from '../../../../../hooks/useForm';
import { createSector } from '../../../../../services';
import { GENERIC_ERROR, SECTOR_ACRONYM_LENGTH } from '../../../../../utils/constantes';

export function CreateSectorPage() {
  const navigate = useNavigate();
  const breadcrumbs = [
    { title: 'Administrativo', functionCoordinator: () => goToAdmin(navigate) },
    { title: 'Setores', functionCoordinator: () => goToSectorsList(navigate) },
    { title: 'Cadastrar' }
  ];

  const initialValueForm = {
    title: '',
    acronym: ''
  };
  const [form, onChange, clearForm] = useForm(initialValueForm);
  const [errorsValidation, setErrorsValidation] = useState({});
  const [loading, setLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    title: '',
    message: '',
    severity: 'error'
  });

  // --- Lógica do modal
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  const onConfirmModal = async () => {
    await create();
  };
  // ---

  const create = async () => {
    try {
      setLoading(true);
      handleClose();
      clearForm();

      await createSector(form.title, form.acronym);

      setAlertMessage((prev) => ({
        ...prev,
        title: 'Setor criado com sucesso.',
        severity: 'success'
      }));

      setLoading(false);
    } catch (error) {
      setAlertMessage({ title: error.message || GENERIC_ERROR });
      setLoading(false);
    }
  };

  const disabledButton = () => {
    if (!form.title) {
      return true;
    }
    if (!form.acronym) {
      return true;
    }

    return false;
  };

  const validateMandatoryInput = (field) => {
    if (!form[field]) {
      setErrorsValidation((prevError) => ({ ...prevError, [field]: true }));
      return;
    }
    setErrorsValidation((prevError) => ({ ...prevError, [field]: false }));
  };

  return (
    <BasePage navigate={navigate} breadcrumbs={breadcrumbs}>
      <TitlePages title={'Cadastrar novo setor'} />

      <Loading loading={loading} />

      <Grid container>
        <AlertMessage
          message={alertMessage.message}
          severity={alertMessage.severity}
          title={alertMessage.title}
          onClose={() => clearAlertMessage(setAlertMessage)}
        />
      </Grid>

      <Form container xs={12} rowGap={2} columnSpacing={isDesktop() && 2}>
        <Grid item xs={12} lg={3}>
          <TextFieldNextFocus
            label="Nome"
            name={'title'}
            required
            value={form.title}
            onChange={onChange}
            onBlur={() => validateMandatoryInput('title')}
            error={errorsValidation.title}
            helperText={errorsValidation.title && 'O nome é obrigatório'}
          />
        </Grid>
        <Grid item xs={12} lg={3}>
          <TextFieldKeyPress
            label="Sigla"
            name={'acronym'}
            required
            value={form.acronym}
            onChange={onChange}
            inputProps={{ maxLength: SECTOR_ACRONYM_LENGTH }}
            onBlur={() => validateMandatoryInput('acronym')}
            error={errorsValidation.acronym}
            helperText={errorsValidation.acronym && 'A sigla é obrigatória'}
          />
        </Grid>
        <Grid item xs={12} className={'buttonGroup twoButtons'}>
          <Button variant="outlined" onClick={() => goToSectorsList(navigate)}>
            Voltar
          </Button>
          <Button onClick={handleOpen} disabled={disabledButton()}>
            Cadastrar
          </Button>
        </Grid>
      </Form>

      <Modal
        open={openModal}
        onClose={handleClose}
        onConfirm={onConfirmModal}
        title={'Cadastrar setor'}
        text={`Tem certeza que deseja criar o setor de ${form.title}? `}
        buttonConfirm={'Sim'}
        buttonCancel={'Não'}
      />
    </BasePage>
  );
}
